import { Button, Stack, styled } from "@mui/material";
import * as React from "react";
import { TooltipRenderProps } from "react-joyride";
import { customTooltipAppearing } from "../../Utils/Helpers/tutorial";
import { useTranslation } from "react-i18next";

export interface CustomTooltipProps extends TooltipRenderProps {}

export const CustomTooltip: React.FC<CustomTooltipProps> = (props) => {
  const { t } = useTranslation();
  const { step, tooltipProps, primaryProps, skipProps, isLastStep } = props;

  return (
    <Wrapper {...tooltipProps}>
      {step.title}
      {step.content}
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Button {...skipProps} variant="white">
          {t("common:skip")}
        </Button>
        <Button {...primaryProps} variant="contained">
          {isLastStep ? t("common:close") : t("common:continue")}
        </Button>
      </Stack>
    </Wrapper>
  );
};

export default CustomTooltip;

const Wrapper = styled(Stack)(({ theme }) => ({
  opacity: 0,
  minWidth: "300px",
  maxWidth: "320px",
  borderRadius: "12px",
  background: "#303049",
  color: theme.palette.common.white,
  padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
  animation: `${customTooltipAppearing} .3s .5s forwards`,
}));
